import { INITIATE_DATA, DELETE_DATA, EDIT_DATA, DISPLAY_UPDATE_FORM, UPDATE_DATA, INITIATE_MAIN_FORM, UPDATE_MAIN_FORM, INITIATE_PGA_DATA, UPDATE_PGA_DATA, UPDATE_REPEATED_SUB_FIELD, UPDATE_REPEATED_SUB_SUB_FIELD, UPDATE_REPEATED_FIELD,
    UPDATE_LACEY_ACT_FIELD, UPDATE_PGA_ITEM_FIELD, INITIATE_DYNAMIC_PGA_DATA, UPDATE_DYNAMIC_PGA_DATA, UPDATE_DYNAMIC_REPEATED_SUB_FIELD,
    UPDATE_DYNAMIC_REPEATED_SUB_SUB_FIELD, UPDATE_DYNAMIC_LACEY_FIELD, UPDATE_DYNAMIC_PGA_ITEM_FIELD, UPDATE_DYNAMIC_REPEATED_FIELD } from "./index"


export const initiate_data = (payload) => {
    return {
        "type": INITIATE_DATA,
        payload
    }
}

export const initiate_main_form = (payload) => {
    return {
        "type": INITIATE_MAIN_FORM,
        payload
    }
}

export const update_data = (payload) => {
    return {
        "type": UPDATE_DATA,
        payload
    }
}

export const delete_data = (payload) => {
    return {
        "type": DELETE_DATA,
        payload
    }
}

export const displayUpdateForm = () => {
    return {
        "type": DISPLAY_UPDATE_FORM
    }
}

export const update_main_form = (field, value, level, index, country, lineItemJson) => {
    console.log("hello from the actions file!!,", country)
    return {
        "type": UPDATE_MAIN_FORM,
        field,
        value,
        level,
        index,
        country,
        lineItemJson
    }
}

export const initiate_pga_data = (payload) => {
    return {
        "type": INITIATE_PGA_DATA,
        payload
    }
}

export const update_pga_data = (pgaGuid,formType, lineItemIndex, fieldName, value, type, isEngine=false) => {
    if(type === "UPDATE_PGA_DATA")
        type = UPDATE_PGA_DATA
    else
        type = UPDATE_DYNAMIC_PGA_DATA
    return {
        pgaGuid,
        "type": type,
        formType,
        lineItemIndex,
        fieldName,
        value,
        isEngine

    }
}

export const update_repeated_sub_Field = (pgaGuid,targetPGA, lineItemIndex, index, field, payload, list,containerCardinality, type, isEngine=false) => {
    if(type === "UPDATE_REPEATED_SUB_FIELD")
        type = UPDATE_REPEATED_SUB_FIELD
    else
        type = UPDATE_DYNAMIC_REPEATED_SUB_FIELD
    return {
        pgaGuid,
        "type": type,
        targetPGA,
        lineItemIndex,
        index,
        field,
        payload,
        list,
        containerCardinality,
        isEngine

    }
}

export const update_repeated_sub_sub_field = (pgaGuid,targetPGA, lineItemIndex, index, field, payload, list,containerCardinality,innerContainerCardinality, type, isEngine=false) => {
    if(containerCardinality < 0){
        update_repeated_field(targetPGA, lineItemIndex, index, field, payload, list, "UPDATE_REPEATED_FIELD", isEngine);
        return update_repeated_field(targetPGA, lineItemIndex, index, field, payload, list, "UPDATE_DYNAMIC_REPEATED_FIELD", isEngine);
    }
    if(type === "UPDATE_REPEATED_SUB_SUB_FIELD")
        type = UPDATE_REPEATED_SUB_SUB_FIELD
    else
        type = UPDATE_DYNAMIC_REPEATED_SUB_SUB_FIELD
    return {
        pgaGuid,
        "type": type,
        targetPGA,
        lineItemIndex,
        index,
        field,
        payload,
        list,
        containerCardinality,
        innerContainerCardinality,
        isEngine
    }
}

export const update_repeated_field = (pgaGuid,targetPGA, lineItemIndex, index, field, payload, list, type, isEngine=false) => {
    if(type === "UPDATE_REPEATED_FIELD")
        type = UPDATE_REPEATED_FIELD
    else
        type = UPDATE_DYNAMIC_REPEATED_FIELD
    return {
        pgaGuid,
        "type": type,
        targetPGA,
        lineItemIndex,
        index,
        field,
        payload,
        list,
        isEngine
    }
}

export const add_repeated_item = (pgaGuid, formType, merchandiseId, lineItemIndex, list, isEngine=false) => {
    return {
        pgaGuid,
        type: "ADD_REPEATED_DYNAMIC_PGA_ITEM",
        targetPGA:formType,
        lineItemIndex,
        list,
        isEngine
    }
}
export const remove_repeated_group = (pgaGuid, formType, merchandiseId, lineItemIndex, index, list) => {
    return {
        pgaGuid,
        type: "REMOVE_REPEATED_GROUP",
        targetPGA:formType,
        lineItemIndex,
        index,
        list
    }
}

export const replace_all_repeated_item_dynamic = (pgaGuid, formType, merchandiseId, lineItemIndex, list, newList, isEngine=false) => {
    return {
        pgaGuid,
        type: "REPLACE_ALL_REPEATED_ITEM_DYNAMIC",
        targetPGA:formType,
        lineItemIndex,
        list,
        newList,
        isEngine
    }
}
export const delete_replace_multiple_PGA_values = (pgaGuid,targetPGA, merchandiseId, lineItemIndex, index, list, newListOfItems,alsoAddThisSave, isEngine=false) => {
    return {
        pgaGuid,
        type: "REPLACE_ALL_REPEATED_ITEM_DYNAMIC",
        targetPGA,
        lineItemIndex,
        list,
        newList:newListOfItems,
        isEngine
    }
}
export function add_repeated_sub_field_dynamic(pgaGuid, targetPGA, merchandiseId, lineItemIndex, list,containerCardinality,initialValues_th, isEngine=false) {
  if(containerCardinality < 0){
    return add_repeated_item(pgaGuid, targetPGA, merchandiseId, lineItemIndex, list, isEngine);
  }
  return {
    type:"ADD_REPEATED_SUB_FIELD_DYNAMIC",
    targetPGA,
    merchandiseId,
    list,
    containerCardinality,
    initialValues_th,
    pgaGuid,
    isEngine
  }
}

export function remove_repeated_sub_group_dynamic(pgaGuid, targetPGA, merchandiseId, lineItemIndex, index, list,containerCardinality, isEngine=false) {
  if(containerCardinality < 0){
    return remove_repeated_group(pgaGuid,targetPGA, merchandiseId, lineItemIndex, index, list, isEngine)
  }
  return {
    type: "REMOVE_SUB_FIELD_GROUPS_DYNAMIC",
    payload: index,
    targetPGA,
    merchandiseId,
    list,
    containerCardinality,
    pgaGuid,
    isEngine
  }
}

export const update_lacey_act_field = (merchandiseId, field, payload, type, isEngine=false) => {
    if(type === "UPDATE_LACEY_ACT_FIELD")
        type = UPDATE_LACEY_ACT_FIELD
    else
        type = UPDATE_DYNAMIC_LACEY_FIELD
    return {
        "type": type,
        merchandiseId,
        field,
        payload,
        isEngine
    }
}

export const update_pga_item_field = (lineItemIndex, index, field, payload, type, isEngine=false) => {
    if(type === "UPDATE_PGA_ITEM_FIELD")
        type = UPDATE_PGA_ITEM_FIELD
    else
        type = UPDATE_DYNAMIC_PGA_ITEM_FIELD
    return {
        "type": type,
        lineItemIndex,
        index,
        field,
        payload,
        isEngine
    }
}

export const initiate_dynamic_pga_data = (payload) => {
    return {
        "type": INITIATE_DYNAMIC_PGA_DATA,
        payload
    }
}